export default "__VITE_ASSET__4e708932__"